import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import {
  DeserializeVoid,
  _post,
} from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ReorderTourItemsControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/tours/reorderTourItems', requestServices);
  }

  public reorderTourItems(
    currentTourId: number,
    tourItemIdToSequenceNumber: Map<number, number>
  ): Promise<void> {
    const request: RequestBody = {
      currentTourId: currentTourId,
      idSequenceNumberPairs: this.getIdSequenceNumberPairs(
        tourItemIdToSequenceNumber
      ),
    };
    return this.post('', request, DeserializeVoid).toPromise();
  }

  public reorderTourItemPairs(
    currentTourId: number,
    idSequenceNumberPairs: IdSequenceNumberPair[]
  ): Promise<void> {
    const request: RequestBody = {
      currentTourId: currentTourId,
      idSequenceNumberPairs: idSequenceNumberPairs,
    };
    return this.post('', request, DeserializeVoid).toPromise();
  }

  private getIdSequenceNumberPairs(
    tourItemIdToSequenceNumber: Map<number, number>
  ): IdSequenceNumberPair[] {
    const toReturn: IdSequenceNumberPair[] = [];
    tourItemIdToSequenceNumber.forEach((sequenceNumber, tourItemId) => {
      toReturn.push({
        tourItemId: tourItemId,
        sequenceNumber: sequenceNumber,
      });
    });
    return toReturn;
  }
}

interface RequestBody {
  currentTourId: number;
  idSequenceNumberPairs: IdSequenceNumberPair[];
}

export interface IdSequenceNumberPair {
  tourItemId: number;
  sequenceNumber: number;
}
